<template>
  <ToggleInput
    class="ui-ToggleControl"
    :value="value"
    :label="label"
    :labelFirst="labelFirst"
    :labelClass="labelClass"
    blockClass="!w-[2.5rem] !h-5 !bg-whiteOverride !border-1 !border-solid !border-border peer-checked:!bg-signableGreen"
    dotClass="!top-0 !left-0 !bg-whiteOverride !border-border peer-checked:!border-border"
    @input="$emit('toggle', !value)"
    :disabled="disabled"
    data-test="toggler"
  />
</template>

<script>
import { defineComponent } from 'vue';

import i18n from '@/locales';

import ToggleInput from '@/components/tailwind/forms/ToggleInput.vue';

export default defineComponent({
  name: 'ToggleControl',
  components: {
    ToggleInput,
  },
  props: {
    value: {
      type: Boolean,
      required: true,
    },
    label: {
      type: String,
      required: false,
      default() {
        return i18n.t('ui.common.cardControls.toggle');
      },
    },
    labelFirst: {
      type: Boolean,
      required: false,
      default: undefined,
    },
    labelClass: {
      type: String,
      required: false,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
});
</script>
